module.exports = __webpack_public_path__ + "static/media/imgPreview.7dd8685.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Notifications/imgPreview.png
// module id = 1423
// module chunks = 0